import React from 'react';
import { Users, Heart, Globe, Camera, Mountain, Waves } from 'lucide-react';
import './AboutUs.css';

function AboutUs() {
  const activities = [
    { icon: Waves, label: 'Scuba Diving' },
    { icon: Mountain, label: 'Trekking & Hiking' },
    { icon: Camera, label: 'Fotografie' },
    { icon: Globe, label: 'Kulturen entdecken' }
  ];

  return (
    <section id="about" className="section about-section">
      <div className="about-container">
        <div className="about-images">
          <div className="about-image-main">
            <img 
              src="https://customer-assets.emergentagent.com/job_nomad-journey-hub/artifacts/8jfm5mut_FullSizeRender%2854%29.JPEG" 
              alt="Thomas & Jasmin in Oman - Wadi Adventure"
              className="main-image"
            />
          </div>
          <div className="about-image-grid">
            <img 
              src="https://images.unsplash.com/photo-1566759996874-04d713cc224a" 
              alt="Adventure"
              className="grid-image"
            />
            <img 
              src="https://images.unsplash.com/photo-1540555413106-fa3a53c36237" 
              alt="Diving"
              className="grid-image"
            />
          </div>
        </div>

        <div className="about-content">
          <h2 className="section-title">Über Just Travel - Dein Reiseblog für preiswerte Weltreisen</h2>
          <p className="section-subtitle">
            Wir sind Thomas & Jasmin - Reiseblogger, die dir zeigen, wie du die Welt mit kleinem Budget entdecken kannst
          </p>

          <div className="about-text">
            <p>
              <strong>Budget-Reisen leicht gemacht:</strong> Just Travel ist dein ultimativer Reiseblog für preiswerte Abenteuer weltweit. 
              Wir zeigen dir, wie du aktive Reisen erleben kannst, ohne dein Budget zu sprengen. Ob günstiges Tauchen auf den Philippinen, 
              Budget-Trekking in den deutschen Alpen oder Street Food Geheimtipps in Bangkok - wir teilen unsere echten Erfahrungen und 
              bewährten Spartipps aus über 20 Ländern.
            </p>

            <p>
              <strong>Insider-Wissen für Sparfüchse:</strong> Als erfahrene Backpacker und Budget-Reisende kennen wir alle Tricks, 
              um günstig zu reisen ohne auf Komfort zu verzichten. Von den besten Flugdeals über preiswerte Unterkünfte bis zu 
              kostenlosen Aktivitäten - bei Just Travel findest du praxiserprobte Reisetipps, die dein Reisebudget schonen.
            </p>

            <p>
              Wir arbeiten beide in Vollzeit und verreisen trotzdem mehrere Monate im Jahr. 
              Unser Geheimnis? Smart planen, flexibel bleiben und lokale Geheimtipps nutzen.
            </p>

            <p>
              <strong>Was uns ausmacht:</strong> Wir bewegen uns gerne abseits der Touristenströme, 
              aber genau so gerne mittendrin. Wir lieben lokale Spezialitäten, aktive Urlaube und 
              authentische Begegnungen mit Menschen aus aller Welt.
            </p>
          </div>

          <div className="activities-grid">
            {activities.map((activity, index) => {
              const Icon = activity.icon;
              return (
                <div key={index} className="activity-card">
                  <Icon size={28} className="activity-icon" />
                  <span className="activity-label">{activity.label}</span>
                </div>
              );
            })}
          </div>

          <div className="about-stats-row">
            <div className="about-stat">
              <div className="about-stat-number">20+</div>
              <div className="about-stat-label">Länder bereist</div>
            </div>
            <div className="about-stat">
              <div className="about-stat-number">100+</div>
              <div className="about-stat-label">Tauchgänge</div>
            </div>
            <div className="about-stat">
              <div className="about-stat-number">50+</div>
              <div className="about-stat-label">Wanderungen</div>
            </div>
          </div>

          <div className="about-cta">
            <Heart size={20} fill="var(--coral)" color="var(--coral)" />
            <p>
              Begleite uns auf unserer Reise und lass dich inspirieren für dein nächstes Abenteuer!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
